module.exports = __webpack_public_path__ + "static/shelter-682e42e54a5d4c74a615fbad51c30cfe.jpg";